export default "__VITE_ASSET__4BiySnUy__"